var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SuperuserTutorEdit", {
        ref: "SuperuserTutorEdit",
        on: { "save-all-changes": _vm.isSubmitAllChangesEnabled },
      }),
      _vm._v(" "),
      _c("SimpleModal", { attrs: { id: "simpleModal" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }